import { render, staticRenderFns } from "./GzzjwhEdit.vue?vue&type=template&id=05f384a0"
import script from "./GzzjwhEdit.vue?vue&type=script&lang=js"
export * from "./GzzjwhEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports